module.exports = __webpack_public_path__ + "assets/4af48638c01f2334f010855dd4a04c4e.svg";